import React, { Fragment, useContext, useState } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import neshan from '../../api/neshan';
import { store as mainStore } from '../../store';
import MessageBox from '../../components/Dialog/Ok';

const DriverLocation = ({ driver }) => {
  const { showMessage, showError } = useContext(mainStore);
  const [address, setAddress] = useState('');

  const fetchLocationString = async () => {
    let { location } = driver;
    location = location?.coordinates;
    if (!location) {
      showError('اطلاعات مکانی راننده یافت نشد.');
      return;
    }
    showMessage('درحال واکاوی آخرین وضعیت راننده', 3);
    try {
      const { data } = await neshan.get(
        `/v2/reverse?lat=${location[0]}&lng=${location[1]}`
      );
      data?.formatted_address && setAddress(data.formatted_address);
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Fragment>
      <IconButton onClick={fetchLocationString}>
        <VisibilityIcon />
      </IconButton>
      <MessageBox
        title="آخرین موقعیت مکانی راننده:"
        open={!!address}
        onClose={() => setAddress('')}
      >
        <div>
          <b>آخرین موقعیت مکانی راننده:</b>
          {address}
          <div>
            <b>وضعیت GPS: </b>
            {!!driver?.gps ? 'روشن' : 'فعلا خاموش'}
          </div>
        </div>
      </MessageBox>
    </Fragment>
  );
};

export default React.memo(DriverLocation);
